import {
  SEND_LEAVE_REQUEST,
  SEND_LEAVE_REQUEST_FAIL,
  SEND_LEAVE_REQUEST_SUCCESS,
} from "./actionType";

const initialState = {
  loading: false,
  error: null,
  requestSentSuccess: [],
};

const LeaveRequest = (state = initialState, action) => {
  switch (action.type) {
    case SEND_LEAVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEND_LEAVE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        requestSentSuccess: action.payload,
      };
    case SEND_LEAVE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default LeaveRequest;
